const RentalDashboardReducer = {
    
}

export default RentalDashboardReducer